import createConverter from './lib/create_converter';
import RoutingGroup from 'models/routing_group';

export default createConverter(RoutingGroup);
